export default __webpack_public_path__ + "static/media/SkammesteinMap.5797b9e7.jpg";